import { Box, IconButton, Stack, SxProps, useTheme } from "@mui/material";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import {
  GetPlayingState,
  GetFrameRate,
  GetTimeInSec,
  PlayPause,
  GoToFrame,
  SetPlayingState,
} from "../../../Redux/Reducers/redux-slice-react-player";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../Redux/redux-store";
import { PauseOutlined, PlayArrow, RefreshOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";

export const PlayingStatus = (props) => {
  const playerisPlaying = useAppSelector(GetPlayingState);
  const { outlined = true, isplaying = true, ...otherProps } = props;

  return isplaying && playerisPlaying ? (
    <PauseIcon {...otherProps} />
  ) : outlined ? (
    <PlayArrowOutlinedIcon {...otherProps} />
  ) : (
    <PlayArrowIcon {...otherProps} />
  );
};

export const BigPlayButton = (props: { hover: boolean; isComplete?: boolean }) => {
  const isPlaying = useAppSelector(GetPlayingState);
  const { hover, isComplete = false } = props;
  const theme = useTheme();

  return (
    <Stack
      sx={{
        width: "10%",
        minWidth: 64,
        maxWidth: 128,
        aspectRatio: "1 / 1",
        borderRadius: 999,
        background: hover ? theme.palette.backgroundAlpha.hover : theme.palette.backgroundAlpha.main,
        color: theme.palette.absolute.white,
      }}
      justifyContent={"center"}
      alignItems={"center"}
      //   onClick={() => {
      //     console.log("click play", isPlaying);
      //     // dispatch(PlayPause());
      //     dispatch(SetPlayingState(true));
      //   }}
    >
      <IconButton
        // onClick={() => {
        //   console.log("click play", isPlaying);
        //   // dispatch(PlayPause());
        //   dispatch(SetPlayingState(true));
        // }}
        sx={{ width: "80%", height: "80%" }}
      >
        {isComplete ? (
          <RefreshOutlined sx={{ width: "80%", height: "80%" }} />
        ) : isPlaying ? (
          <PauseOutlined sx={{ width: "80%", height: "80%" }} />
        ) : (
          <PlayArrow sx={{ width: "80%", height: "80%" }} />
        )}
      </IconButton>
    </Stack>
  );
};

export const PlayingStatusByTimecode = (props) => {
  const { _onClickPlay, timecode, SetIsPlayingByTimecode, isplaying: isPlayingEnable, ...otherProps } = props;
  const dispatch = useAppDispatch();
  const frameRate = useAppSelector(GetFrameRate);
  const currentFrame: number = useAppSelector(GetTimeInSec) * frameRate || 0;
  let isplaying: boolean = isPlayingEnable
    ? timecode.in.markFrame <= currentFrame && timecode.out.markFrame > currentFrame
    : false;

  React.useEffect(() => SetIsPlayingByTimecode(isplaying), [isplaying]);

  const code = React.useMemo(() => {
    return (
      <IconButton
        sx={{ mr: 0.5, flexShrink: 0 }}
        onClick={(e) => {
          if (!_onClickPlay || _onClickPlay(e)) {
            if (timecode.in.markFrame <= currentFrame && timecode.out.markFrame > currentFrame) dispatch(PlayPause());
            else dispatch(GoToFrame(timecode.in.markFrame));
          }
        }}
      >
        <PlayingStatus {...otherProps} isplaying={isplaying}></PlayingStatus>
      </IconButton>
    );
  }, [isplaying]);

  return code;
};
